"use client";

import { cn } from "@drpcrd/utils";

type Props = {
  className?: string;
};

/**
 * Empty state slider for rate card comparison when no estimated rate is available.
 */
export const RateCardComparisonEmptyState = ({ className }: Props) => (
  <div className={cn("relative w-full", className)}>
    <div className="bg-primary-50 h-3 w-full rounded" />
  </div>
);
